// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__14Q4h","description":"PatientConsentPreview_description__3GiT9"};